const ResponseActionName = "SwitchTenantConfirmation";
const AppEventName = "SwitchTenantExecute";
const validateResponseActionName = (actionName) => {
    return actionName === ResponseActionName;
};
export function processSwitchTenantConfirmationAction(response, almeApiUtils, almeState, setAlmeState) {
    try {
        if (!(response === null || response === void 0 ? void 0 : response.responseActions)) {
            return;
        }
        for (const action of response.responseActions) {
            if (validateResponseActionName(action.Name) && action.ClientAccessKey) {
                almeApiUtils.sendAppEvent(AppEventName, undefined, { "ClientAccessKey": action.ClientAccessKey })
                    .then((resp) => {
                    almeApiUtils.appendToHistory(resp);
                    const accessKey = action.ClientAccessKey;
                    setAlmeState(Object.assign(Object.assign({}, almeState), { accessKey: accessKey, isOpen: !almeState.isOpen ? true : almeState.isOpen, lastEntryId: resp ? resp.extensionData.entryId : undefined }));
                })
                    .catch((error) => console.error(error));
                return;
            }
        }
    }
    catch (error) {
        console.error(error);
    }
}
